import BusinessLogicException from "exceptions/BusinessLogicException";
import type { AbstractFileEntity } from "features/merchantPayouts/types";
import { generateFileName } from "util/support";
import type { ActionHookArg } from "../Props";
import useActionHandler from "./useActionHandler";

const defaultRequestHandler = async (
    fileEntity: Pick<AbstractFileEntity, 'coreId' | 'MOR'>,
    fileName: string
) => new Response();

export default function useTransactionsCSV<T extends AbstractFileEntity>({
    row,
    handler = defaultRequestHandler
}: ActionHookArg<
    T,
    typeof defaultRequestHandler
>) {
    const actionHandler = useActionHandler(row);

    return actionHandler(async () => {
        if (!row.coreId) {
            throw new BusinessLogicException("Invalid ID!", {});
        }

        const response = await handler(
            row,
            generateFileName({
                prefix: 'Transactions',
                fileKey: row.fileKey ?? row.coreId.toString(),
                extension: 'csv'
            })
        );

        if (!response.ok) {
            throw new BusinessLogicException("Something went wrong while generating .CSV file", { response });
        }
    });
};
